export default "assets/images/logo-blue-961d0b8d.png";